export default "__VITE_ASSET__C6QpRL4r__"